import _ from 'lodash';
import BaseCtrl from 'edge/platform/base/BaseCtrl';

const fn = function ($scope, claimViewModel) {
    const ctrl = Object.create(BaseCtrl);

    ctrl.init = function () {
        $scope.claimVm = claimViewModel();
        $scope.claimVm.lossCause.value = $scope.claimVm.lossCause.value || 'burglary';

        $scope.crimeTypes = {
            'burglary': _.find($scope.claimVm.lossCause.aspects.availableValues, {
                code: 'burglary'
            }),
            'vandalism': _.find($scope.claimVm.lossCause.aspects.availableValues, {
                code: 'vandalism'
            }),
            'riotandcivil': _.find($scope.claimVm.lossCause.aspects.availableValues, {
                code: 'riotandcivil'
            })
        };
    };

    return ctrl.create($scope);
};
fn.$inject = ['$scope', 'claimViewModel'];

export default fn;